import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

// Where "here" points: the AI Credits and Billing help article.
const AI_CREDITS_BILLING_URL = 'https://zakeke.zendesk.com/hc/en-us/articles/31154048227740-AI-Credits-and-Billing';

const Notice = styled.small`
    display: block;
    margin-top: 6px;
    font-size: 11px;
    font-style: italic;
    line-height: 1.4;
    text-align: center;
    color: ${(props) => props.theme.app.component.icon.button.default.color};
`;

const NoticeLink = styled.a`
    color: ${(props) => props.theme.ai.solid};
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
`;

// Small print under the prompt fields that generate something: every output is paid for in credits.
export const AiCreditsNotice: FC = () => (
    <Notice>
        {T._('Each output you generate uses AI credits. You start with free credits, then usage is billed automatically.', 'Admin')}{' '}
        <NoticeLink href={AI_CREDITS_BILLING_URL} target='_blank' rel='noopener noreferrer'>
            {T._('How AI credits work', 'Admin')}
        </NoticeLink>
        .
    </Notice>
);

/**
 * The same small print under the prompt of the assistant, where the rule reads differently: talking
 * to it costs nothing, and anything that does is stated before it runs.
 */
export const AiChatCreditsNotice: FC = () => (
    <Notice>
        {T._('Chatting with the assistant is free. Operations that use AI credits are shown before they run the first time.', 'Admin')}{' '}
        <NoticeLink href={AI_CREDITS_BILLING_URL} target='_blank' rel='noopener noreferrer'>
            {T._('How AI credits work', 'Admin')}
        </NoticeLink>
        .
    </Notice>
);

export default AiCreditsNotice;
